__turbopack_context__.v({
  "cardWrap": "I2vIPa_cardWrap",
  "container": "I2vIPa_container",
  "dailyCommander": "I2vIPa_dailyCommander",
  "heading": "I2vIPa_heading",
  "headingKicker": "I2vIPa_headingKicker",
  "headingTitle": "I2vIPa_headingTitle",
  "list": "I2vIPa_list",
});
